import { techDocs } from "../../e-learning/technical-docs";

export default techDocs('customer_support', 'Suporte ao cliente', 'documentos-tecnicos-suporte-cliente')